import { BonusPagesEnum } from "@finbackoffice/fe-core";
import { SiteContentScopes, TranslationScopes, AssetsDirectory } from "@finbackoffice/enums";
import { RouteNames, RouterQuery } from "./index";

export type PromoRegistryItem = {
    page: BonusPagesEnum;
    href: string;
    bannerScope: SiteContentScopes;
    translationScope: TranslationScopes;
    pageNameTid: string;
    menuLabelTid: string;
    menuIcon: string;
    listTestId: string;
    iconPath: string;
    casinoGameId?: string;
};

const bonusMenuIconPath = `/${AssetsDirectory.Common}/${AssetsDirectory.Mobile}/${AssetsDirectory.Bonuses}`;
const profilePromoIconPath = `/${AssetsDirectory.Mobile}/${AssetsDirectory.ProfileCompact}`;

export const PROMO_REGISTRY: PromoRegistryItem[] = [
    {
        page: BonusPagesEnum.Referral,
        href: `/${RouteNames.BONUSES}/${RouteNames.BONUS_REFERRAL}`,
        bannerScope: SiteContentScopes.BonusReferral,
        translationScope: TranslationScopes.BonusesReferral,
        pageNameTid: "pageName_bonuses_referral",
        menuLabelTid: "bonuses_menu_referral",
        menuIcon: `${bonusMenuIconPath}/bonuses-referral.svg`,
        listTestId: "account-menu-item-referral",
        iconPath: `${profilePromoIconPath}/profile-promotions-referral.svg`,
    },
    {
        page: BonusPagesEnum.Cashback,
        href: `/${RouteNames.BONUSES}/${RouteNames.CASHBACK}`,
        bannerScope: SiteContentScopes.BonusCashback,
        translationScope: TranslationScopes.BonusesCashback,
        pageNameTid: "pageName_bonuses_cashback",
        menuLabelTid: "bonuses_menu_cashback",
        menuIcon: `${bonusMenuIconPath}/bonuses-cashback.svg`,
        listTestId: "account-menu-item-cashback",
        iconPath: `${profilePromoIconPath}/profile-promotions-cashback.svg`,
    },
    {
        page: BonusPagesEnum.Casino,
        href: `/${RouteNames.BONUSES}/${RouteNames.PROMOTIONS}/${RouterQuery.Casino}`,
        bannerScope: SiteContentScopes.BonusPromoCasino,
        translationScope: TranslationScopes.BonusPromoCasino,
        pageNameTid: "pageName_bonuses_promo_casino",
        menuLabelTid: "bonuses_menu_casino",
        menuIcon: `${bonusMenuIconPath}/bonuses-promotions.svg`,
        listTestId: "account-menu-item-casino",
        iconPath: `${profilePromoIconPath}/profile-promotions-promotions.svg`,
    },
    {
        page: BonusPagesEnum.Casino2,
        href: `/${RouteNames.BONUSES}/${RouteNames.PROMOTIONS}/${RouterQuery.Casino2}`,
        bannerScope: SiteContentScopes.BonusPromoCasino2,
        translationScope: TranslationScopes.BonusPromoCasino2,
        pageNameTid: "pageName_bonuses_promo_casino_2",
        menuLabelTid: "bonuses_menu_casino_2",
        menuIcon: `${bonusMenuIconPath}/bonuses-promotions.svg`,
        listTestId: "account-menu-item-casino_2",
        iconPath: `${profilePromoIconPath}/profile-promotions-promotions.svg`,
    },
    {
        page: BonusPagesEnum.Promo2,
        href: `/${RouteNames.BONUSES}/${RouteNames.PROMOTIONS}/${RouterQuery.Promo2}`,
        bannerScope: SiteContentScopes.BonusPromo2,
        translationScope: TranslationScopes.BonusesPromo2,
        pageNameTid: "pageName_bonuses_promo_2",
        menuLabelTid: "bonuses_menu_promo_2",
        menuIcon: `${bonusMenuIconPath}/bonuses-promotions.svg`,
        listTestId: "account-menu-item-promo_2",
        iconPath: `${profilePromoIconPath}/profile-promotions-promotions.svg`,
    },
    {
        page: BonusPagesEnum.Promo3,
        href: `/${RouteNames.BONUSES}/${RouteNames.PROMOTIONS}/${RouterQuery.Promo3}`,
        bannerScope: SiteContentScopes.BonusPromo3,
        translationScope: TranslationScopes.BonusesPromo3,
        pageNameTid: "pageName_bonuses_promo_3",
        menuLabelTid: "bonuses_menu_promo_3",
        menuIcon: `${bonusMenuIconPath}/bonuses-promotions.svg`,
        listTestId: "account-menu-item-promo_3",
        iconPath: `${profilePromoIconPath}/profile-promotions-promotions.svg`,
    },
    {
        page: BonusPagesEnum.Promo4,
        href: `/${RouteNames.BONUSES}/${RouteNames.PROMOTIONS}/${RouterQuery.Promo4}`,
        bannerScope: SiteContentScopes.BonusPromo4,
        translationScope: TranslationScopes.BonusesPromo4,
        pageNameTid: "pageName_bonuses_promo_4",
        menuLabelTid: "bonuses_menu_promo_4",
        menuIcon: `${bonusMenuIconPath}/bonuses-promotions.svg`,
        listTestId: "account-menu-item-promo_4",
        iconPath: `${profilePromoIconPath}/profile-promotions-promotions.svg`,
    },
    {
        page: BonusPagesEnum.Promo5,
        href: `/${RouteNames.BONUSES}/${RouteNames.PROMOTIONS}/${RouterQuery.Promo5}`,
        bannerScope: SiteContentScopes.BonusPromo5,
        translationScope: TranslationScopes.BonusesPromo5,
        pageNameTid: "pageName_bonuses_promo_5",
        menuLabelTid: "bonuses_menu_promo_5",
        menuIcon: `${bonusMenuIconPath}/bonuses-promotions.svg`,
        listTestId: "account-menu-item-promo_5",
        iconPath: `${profilePromoIconPath}/profile-promotions-promotions.svg`,
    },
    {
        page: BonusPagesEnum.Promo6,
        href: `/${RouteNames.BONUSES}/${RouteNames.PROMOTIONS}/${RouterQuery.Promo6}`,
        bannerScope: SiteContentScopes.BonusPromo6,
        translationScope: TranslationScopes.BonusesPromo6,
        pageNameTid: "pageName_bonuses_promo_6",
        menuLabelTid: "bonuses_menu_promo_6",
        menuIcon: `${bonusMenuIconPath}/bonuses-promotions.svg`,
        listTestId: "account-menu-item-promo_6",
        iconPath: `${profilePromoIconPath}/profile-promotions-promotions.svg`,
    },
    {
        page: BonusPagesEnum.Promo7,
        href: `/${RouteNames.BONUSES}/${RouteNames.PROMOTIONS}/${RouterQuery.Promo7}`,
        bannerScope: SiteContentScopes.BonusPromo7,
        translationScope: TranslationScopes.BonusesPromo7,
        pageNameTid: "pageName_bonuses_promo_7",
        menuLabelTid: "bonuses_menu_promo_7",
        menuIcon: `${bonusMenuIconPath}/bonuses-promotions.svg`,
        listTestId: "account-menu-item-promo_7",
        iconPath: `${profilePromoIconPath}/profile-promotions-promotions.svg`,
    },
    {
        page: BonusPagesEnum.Promo8,
        href: `/${RouteNames.BONUSES}/${RouteNames.PROMOTIONS}/${RouterQuery.Promo8}`,
        bannerScope: SiteContentScopes.BonusPromo8,
        translationScope: TranslationScopes.BonusesPromo8,
        pageNameTid: "pageName_bonuses_promo_8",
        menuLabelTid: "bonuses_menu_promo_8",
        menuIcon: `${bonusMenuIconPath}/bonuses-promotions.svg`,
        listTestId: "account-menu-item-promo_8",
        iconPath: `${profilePromoIconPath}/profile-promotions-promotions.svg`,
    },
    {
        page: BonusPagesEnum.Promo9,
        href: `/${RouteNames.BONUSES}/${RouteNames.PROMOTIONS}/${RouterQuery.Promo9}`,
        bannerScope: SiteContentScopes.BonusPromo9,
        translationScope: TranslationScopes.BonusesPromo9,
        pageNameTid: "pageName_bonuses_promo_9",
        menuLabelTid: "bonuses_menu_promo_9",
        menuIcon: `${bonusMenuIconPath}/bonuses-promotions.svg`,
        listTestId: "account-menu-item-promo_9",
        iconPath: `${profilePromoIconPath}/profile-promotions-promotions.svg`,
    },
    {
        page: BonusPagesEnum.Aviator,
        href: `/${RouteNames.BONUSES}/${RouteNames.PROMOTIONS}/${RouterQuery.Aviator}`,
        bannerScope: SiteContentScopes.BonusPromoAviator,
        translationScope: TranslationScopes.BonusesPromoAviator,
        pageNameTid: "pageName_bonuses_promo_aviator",
        menuLabelTid: "bonuses_menu_promo_aviator",
        menuIcon: `${bonusMenuIconPath}/bonuses-sr_sr-aviator.svg`,
        listTestId: "",
        iconPath: `${profilePromoIconPath}/profile-promotions-promotions.svg`,
        casinoGameId: "sr_sr-aviator",
    },
];

export const PROMO_REGISTRY_BY_PAGE = PROMO_REGISTRY.reduce(
    (acc, item) => {
        acc[item.page] = item;
        return acc;
    },
    {} as Record<BonusPagesEnum, PromoRegistryItem>,
);

export const BONUS_TRANSLATION_SCOPES_BY_PAGE = PROMO_REGISTRY.reduce(
    (acc, item) => {
        if (item.translationScope) {
            acc[item.page] = item.translationScope;
        }
        return acc;
    },
    {} as Record<BonusPagesEnum, TranslationScopes>,
);
